import React, { useEffect, FC } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import type { Stripe, StripeElements, StripePaymentElementChangeEvent } from '@stripe/stripe-js';
import {
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';

interface StripePaymentElementProps {
  setStripe: Dispatch<SetStateAction<Stripe | null>>;
  setElements: Dispatch<SetStateAction<StripeElements | null>>;
  options?: Record<string, unknown>;
  onChange?: (event: StripePaymentElementChangeEvent) => void;
}

const StripePaymentElement: FC<StripePaymentElementProps> = ({
  setStripe,
  setElements,
  options,
  onChange,
}) => {
  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    if (stripe && elements) {
      setStripe(stripe);
      setElements(elements);
    }
  }, [stripe, elements]);

  return <PaymentElement options={options} onChange={onChange} />;
};

export { StripePaymentElement };
